module.exports = __webpack_public_path__ + "assets/CertificacaoEntidadesGestoras.504c93dd774fec74bdf0a7779e104165.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/CertificacaoEntidadesGestoras.png
 ** module id = 480
 ** module chunks = 0
 **/